import Radar from '@mui/icons-material/Radar'
import { Box, Stack, Typography } from '@mui/material'

import { useBuildProgressConfig } from '@/atoms'

import { useTexts } from '../useTexts'

export function OptimizationConfigPanel() {
  const texts = useTexts()
  const config = useBuildProgressConfig()

  if (!config) return null

  return (
    <Box
      sx={{
        bgcolor: t => t.palette.background.default2 ?? '#F3F5F7',
        borderRadius: 1,
        p: 2,
      }}
    >
      <Stack spacing={0.5}>
        <Typography
          variant="subtitle3"
          sx={{ fontWeight: 500, fontSize: 16, color: t => t.vars.palette.text.primary }}
        >
          {texts.optimizationConfiguration}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Radar sx={{ fontSize: 16, color: t => t.vars.palette.action.active }} />
          <Typography variant="body1">{config.strategyLabel}</Typography>
        </Stack>
      </Stack>
    </Box>
  )
}
